export default "__VITE_ASSET__C$$uwScQ__"